import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFormattedDate } from 'utils/DataFormatUtils';
import { etapaIsUnlocked } from 'utils/ProjetoUtils';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { HelpButton } from '../../../../../components/HelpButton';
import { DateMaskedInput } from '../../../../../components/MaskedInputs';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { PROFILE_PUFV_PROFESSOR } from '../../../../../library/Profiles';
import { changeProjetoValue } from '../../../../../store/modules/ProjetoActions';
import { getPropsToLabel } from '../../../../../utils/HelpButtonUtils';
import { getInputFocusInFocusOutAttr } from '../../../../../utils/HTMLUtils';
import {
  dateIsValid,
  maskedValueRequiredIsValid,
  periodIsValid,
} from '../../../../../utils/ValidationUtils';
import { Col } from './../../../../../components/Col';
import { Row } from './../../../../../components/Row';

class PreEtapa2 extends GenericProjectCard {
  stepIndex = 0;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      nomeChanged: false,
      cpfsProfessoresChanged: false,
    };

    this.setValue = this.setValue.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const cpfProfessor = this.getProfileCPFWhenIsProfessor();
    if (newProps.projeto.idEscola !== this.props.projeto.idEscola) {
      if (!this.props.projeto.id && typeof cpfProfessor === 'string') {
        this.setValue({
          target: {
            name: 'cpfsProfessores',
            value: [cpfProfessor],
          },
        });
      }
    }
  }

  nomeIsValid() {
    return this.props.projeto.nome.trim().length > 0;
  }

  assessoresIsValid() {
    return this.props.projeto.cpfsProfessores.length > 0;
  }

  periodIsValid = (value1, value2, validationError) => {
    const validation = periodIsValid(value1, value2, validationError);
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  inicialPeriodIsValid = () => {
    const requiredErrorMessage =
      this.props.languageValues.validations.projectInicialPeriod.required;
    const validationErrorMessage =
      this.props.languageValues.validations.projectInicialPeriod.validation;
    const required = maskedValueRequiredIsValid(
      this.props.projeto.periodoInicial,
      requiredErrorMessage
    );
    if (!required.status) {
      return required;
    }
    const validation = dateIsValid(
      this.props.projeto.periodoInicial,
      validationErrorMessage
    );
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  finalPeriodIsValid = () => {
    const requiredErrorMessage =
      this.props.languageValues.validations.projectFinalPeriod.required;
    const validationErrorMessage =
      this.props.languageValues.validations.projectFinalPeriod.validation;
    const required = maskedValueRequiredIsValid(
      this.props.projeto.periodoFinal,
      requiredErrorMessage
    );
    if (!required.status) {
      return required;
    }
    const validation = this.periodIsValid(
      this.props.projeto.periodoInicial,
      this.props.projeto.periodoFinal,
      validationErrorMessage
    );
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  focusIn = (fieldName) => {
    this.setState({
      ...this.state,
      focusedFieldName: fieldName,
    });
  };

  focusOut = (fieldName) => {
    if (this.state.focusedFieldName === fieldName) {
      this.setState({
        ...this.state,
        focusedFieldName: null,
      });
    }
  };

  fieldDisabled() {
    return this.state.saving === true || this.state.loading === true
      ? true
      : false;
  }

  getProfileCPFWhenIsProfessor = () => {
    if (
      this.props.auth.userPermissions.perfil === PROFILE_PUFV_PROFESSOR.id &&
      typeof this.props.auth.userPermissions.cpf === 'string'
    ) {
      return this.props.auth.userPermissions.cpf;
    }
    return null;
  };

  render() {
    this.validationResults = [
      this.nomeIsValid(),
      this.assessoresIsValid(),
      this.inicialPeriodIsValid().status,
      this.props.projeto.periodoFinal === ''
        ? true
        : this.finalPeriodIsValid().status,
    ];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintPreEtapa}
        CardHeaderPropTypes={{
          title: this.props.languageValues.preCadastro,
        }}
      >
        <form
          className={this.getFormClasses(false)}
          onSubmit={(event) => {
            event.preventDefault();
            if (this.itemsAreValid(this.validationResults)) {
              this.toNext();
            }
          }}
        >
          <Row>
            <Col
              cols={
                this.props.projeto.periodoFinal !== ''
                  ? [6, 6, 6, 6, 6]
                  : [12, 12, 12, 12, 12]
              }
            >
              <CustomTextField
                label={this.props.languageValues.periodoInicial}
                name='periodoInicial'
                value={this.props.projeto.periodoInicial || ''}
                onChange={(evt) => {
                  const { value } = evt.target;
                  evt.target.value = getFormattedDate(value);
                  this.setValue(evt);
                }}
                helperText={
                  !this.inicialPeriodIsValid().status
                    ? this.inicialPeriodIsValid().error
                    : ''
                }
                error={!this.inicialPeriodIsValid().status}
                disabled={this.props.lockedAllFields || this.fieldDisabled()}
              />
            </Col>
            {this.props.projeto.periodoFinal !== '' ? (
              <Col cols={[6, 6, 6, 6, 6]}>
                <CustomTextField
                  label={this.props.languageValues.periodoFinal}
                  name='periodoFinal'
                  value={this.props.projeto.periodoFinal || ''}
                  onChange={this.setValue}
                  helperText={
                    this.inicialPeriodIsValid().status &&
                    !this.finalPeriodIsValid().status
                      ? this.finalPeriodIsValid().error
                      : ''
                  }
                  error={
                    this.inicialPeriodIsValid().status &&
                    !this.finalPeriodIsValid().status
                  }
                  disabled={
                    this.props.lockedAllFields ||
                    this.fieldDisabled() ||
                    !this.inicialPeriodIsValid().status
                  }
                  InputProps={{
                    inputComponent: DateMaskedInput,
                  }}
                  {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
                />
              </Col>
            ) : null}
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextField
                label={
                  <>
                    {this.props.languageValues.preTitulo}
                    <HelpButton
                      text={this.props.languageValues.hintPreEtapaTitulo}
                      {...getPropsToLabel()}
                    />
                  </>
                }
                name='nome'
                value={this.props.projeto.nome}
                onChange={(event) => {
                  this.setValue(event);
                }}
                counter={true}
                maxSize={200}
                error={!this.nomeIsValid()}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                label={this.props.languageValues.educadores}
                placeholder={
                  this.props.professores.loadingEducadoresList
                    ? this.props.languageValues.carregandoEducadores
                    : ''
                }
                options={this.props.professores.educadoresList.map((item) => {
                  return {
                    label: item.nome,
                    value: item.cpf,
                  };
                })}
                multiple
                value={this.props.projeto.cpfsProfessores}
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'cpfsProfessores',
                      value: currValue,
                    },
                  });
                }}
                loading={this.props.professores.loadingEducadoresList}
                loadingMessage={this.props.languageValues.carregandoEducadores}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
                error={!this.assessoresIsValid()}
                helperText={
                  !this.assessoresIsValid()
                    ? this.props.languageValues.validations.professores.required
                    : ''
                }
              />
            </Col>
          </Row>
          {this.getActionsRow([
            [
              this.getPreviousButton(true),
              this.getNextButton(this.itemsAreValid(this.validationResults)),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
  professores: state.professores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PreEtapa2);
